import React, { useCallback } from 'react';

import { useHistory, useParams } from 'react-router-dom';

import InclusionsFilterBulkModal from './InclusionsFilterBulkModal';

type Props = {
  vendorId: string;
  onSave: () => void;
};

function InclusionsFilterCreate({ vendorId, onSave }: Props) {
  const { inclusionId } = useParams<{ inclusionId: string }>();
  const history = useHistory();

  const handleClose = useCallback(() => {
    history.push(`/cruises/inclusions/edit/${inclusionId}/filters`);
  }, [history, inclusionId]);

  return (
    <InclusionsFilterBulkModal
      open
      inclusionId={inclusionId}
      vendorId={vendorId}
      onSave={onSave}
      onClose={handleClose}
    />
  );
}

export default InclusionsFilterCreate;
